<template>
  <div class="app" @click.stop="closeAllPopups">
    <AppHeader v-if="currentUser.id"
               @log-out="showLogOutConfirmation"
    />
    <AppMenu v-if="currentUser.id"
             @log-out="showLogOutConfirmation"
    />

    <router-view v-if="currentUser.id"/>

    <LoginForm v-if="!currentUser.logged_in"/>

    <transition name="fade">
      <ThePagePreloader position="app" v-if="currentUser.logged_in && userDataLoading" />
    </transition>

    <transition name="fade">
      <AppModal v-if="loginErrorIsActive"
                title="Ошибка авторизации!"
                text="Пожалуйста, авторизуйтесь повторно или обратитесь в поддержку"
                confirm-button-title="Закрыть"
                confirm-button-type="main"
                @confirm="hideLoginErrorMessage"
      />
    </transition>

    <!-- модалка подтверждения выхода -->
    <transition name="fade">
      <AppModal v-if="confirmation_active"
                title="Вы действительно хотите выйти из приложения?"
                confirm-button-type="main"
                confirm-button-title="Да"
                reject-button-type="alt"
                reject-button-title="Нет"
                @confirm="logOut"
                @reject="closeLogOutConfirmation"
      />
    </transition>
    <!-- /модалка подтверждения выхода -->
  </div>
</template>

<script>
import AppHeader from './components/header/AppHeader.vue'
import AppMenu from './components/menu/AppMenu.vue'
import LoginForm from './components/page/modal/LoginForm'
import ThePagePreloader from './components/page/ThePagePreloader'
import AppModal from '@/components/page/modal/AppModal'
import { mapGetters } from 'vuex'

require('flatpickr/dist/flatpickr.css')
require('vue-multiselect/dist/vue-multiselect.min.css')
require('swiper/swiper-bundle.css')

export default {
  name: 'App',
  components: {
    AppModal,
    ThePagePreloader,
    AppMenu,
    AppHeader,
    LoginForm
  },
  data () {
    return {
      confirmation_active: false
    }
  },

  computed: {
    ...mapGetters([
      'getMediaBreakpoint',
      'currentUser',
      'currentUserData',
      'loginErrorIsActive',
      'getNewDialogCounter'
    ]),

    // нужно прикрывать интерфейс прелоадером, пока данные пользователя не загрузились
    userDataLoading () {
      return this.currentUserData.isLoading
    }
  },

  methods: {
    closeAllPopups () {
      this.$store.dispatch('closeAllPopups')
    },
    showLogOutConfirmation () {
      this.confirmation_active = true
    },
    closeLogOutConfirmation () {
      this.confirmation_active = false
    },
    hideLoginErrorMessage () {
      this.$store.commit('HIDE_LOGIN_ERROR_MESSAGE')
    },
    logOut () {
      this.$store.dispatch('logOut')
      this.confirmation_active = false
    }
  },
  mounted () {
    this.$store.dispatch('checkLoggedUser')
    this.$store.dispatch('setCurrentMediaBreakPoint')
    this.$store.dispatch('setCurrentUserAgent')
  }
}
</script>
